import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { FunctionalLocation } from "@/classes";
import FunctionalLocationDialog from "@/components/functional-location/FunctionalLocationDialog.vue";
import PaginatedTable from "@/components/base/tables/PaginatedTable.vue";
import { FilterDefinition } from "@/types/filter";
import { DataTableHeader } from "@/types/table";
import FunctionalLocationImport from "@/components/functional-location/FunctionalLocationImport.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'functional-locations',
  setup(__props) {

const headers: DataTableHeader[] = [
  {
    title: "Sup. Func. Loc.",
    key: "superior_functional_location",
    sortable: true,
  },
  {
    title: "Func. Loc.",
    key: "functional_location",
    sortable: true,
  },
  {
    title: "Is Asset",
    key: "is_asset_text",
    sortable: true,
    sortkey: "is_asset",
  },
  {
    title: "Asset Class",
    key: "asset_class_name",
    sortable: true,
  },
  {
    title: "Func. Loc. Description",
    key: "functional_location_description",
    sortable: true,
  },
  {
    title: "Cost Center",
    key: "cost_center",
    sortable: true,
  },
  {
    title: "Main Work Center",
    key: "main_work_center",
    sortable: true,
  },
  {
    title: "Func. Loc. Category",
    key: "functional_location_category",
    sortable: true,
  },
  {
    title: "Action",
    key: "actions",
    sortable: false,
  },
];

const filterDefinitions: FilterDefinition[] = [
  {
    label: "Sup. Func. Loc.",
    value: "superior_functional_location",
    type: "string",
  },
  {
    label: "Func. Loc.",
    value: "functional_location",
    type: "string",
  },
  {
    label: "Is Asset",
    value: "is_asset",
    type: "boolean",
  },
  {
    label: "Asset Class",
    value: "asset_class_id",
    type: "reflist",
    reflist: "assetClasses",
    itemValue: "id",
    itemText: "name",
    multiple: true,
  },
  {
    label: "Func. Loc. Description",
    value: "functional_location_description",
    type: "string",
  },
  {
    label: "Main Work Center",
    value: "main_work_center",
    type: "string",
  },
  {
    label: "Cost Center",
    value: "cost_center",
    type: "string",
  },
  {
    label: "Func. Loc. Category",
    value: "functional_location_category",
    type: "string",
  },
];

const table = ref<InstanceType<typeof PaginatedTable> | null>(null);
const dialog = ref<InstanceType<typeof FunctionalLocationDialog> | null>(null);
const importer = ref<InstanceType<typeof FunctionalLocationImport> | null>(
  null,
);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PaginatedTable, {
      ref_key: "table",
      ref: table,
      table: "functional-locations",
      "table-class": _unref(FunctionalLocation),
      "filter-definitions": filterDefinitions,
      headers: headers
    }, {
      "right-actions": _withCtx(() => [
        _createVNode(_component_v_btn, {
          "aria-label": "Import Functional Locations",
          color: "secondary",
          class: "mr-2",
          flat: "",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (importer.value.open()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode("mdi-upload")
              ]),
              _: 1
            }),
            _createTextVNode("Import ")
          ]),
          _: 1
        })
      ]),
      "item.actions": _withCtx(({ item }) => [
        _createVNode(_component_v_btn, {
          "aria-label": "View Functional Location",
          title: "View",
          icon: "mdi-eye",
          flat: "",
          density: "compact",
          onClick: ($event: any) => (dialog.value?.open(item.id))
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["table-class"]),
    _createVNode(FunctionalLocationImport, {
      ref_key: "importer",
      ref: importer,
      onImported: _cache[1] || (_cache[1] = ($event: any) => (table.value?.getData()))
    }, null, 512),
    _createVNode(FunctionalLocationDialog, {
      ref_key: "dialog",
      ref: dialog,
      onChange: _cache[2] || (_cache[2] = ($event: any) => (table.value?.getData()))
    }, null, 512)
  ]))
}
}

})